import { useContext } from 'react';
import PropTypes from 'prop-types';
import i18nContext from 'components/i18n-context';
import { amountFormattedValue, getErrorMessageForAlert } from 'services/utils';
import Alert from 'uikit/Alert/Alert';
import Button from 'uikit/Button/Button';
import './BetweenAccountsConfirmationTab.scss';

const BetweenAccountsConfirmationTab = ({ transferData, onConfirm, error, isLoading }) => {
  const i18n = useContext(i18nContext);

  const renderDetailRow = (label, value) => {
    if (!value) return null;
    return (
      <div className={'confirmation-detail-row'}>
        <div className={'confirmation-detail-label'}>{label}</div>
        <div className={'confirmation-detail-value'}>{value}</div>
      </div>
    );
  };

  return (
    <div className={'between-accounts-confirmation'}>
      <div className={'confirmation-details'}>
        {renderDetailRow(i18n.getMessage('betweenAccounts.form.from'), transferData.from)}
        {renderDetailRow(i18n.getMessage('betweenAccounts.form.to'), transferData.to)}
        {renderDetailRow(
          i18n.getMessage('betweenAccounts.form.amount'),
          `${transferData.currency} ${amountFormattedValue(transferData.amount)}`
        )}
        {renderDetailRow(
          i18n.getMessage('betweenAccounts.form.commission'),
          `${transferData.currency} ${amountFormattedValue(transferData?.commission)}`
        )}
        {renderDetailRow(i18n.getMessage('betweenAccounts.input.description.label'), transferData.description)}
      </div>

      <Alert type={'warning'} className={'confirmation-alert'} message={getErrorMessageForAlert(i18n, error)} />

      <div className={'confirmation-actions'}>
        <Button type={'primary'} size={'large'} fullWidth={true} onClick={onConfirm} isLoading={isLoading}>
          {i18n.getMessage('betweenAccounts.button.confirm')}
        </Button>
      </div>
    </div>
  );
};

BetweenAccountsConfirmationTab.propTypes = {
  transferData: PropTypes.shape({
    from: PropTypes.string,
    to: PropTypes.string,
    amount: PropTypes.string,
    commission: PropTypes.string,
    currency: PropTypes.string,
    description: PropTypes.string
  }),
  onConfirm: PropTypes.func.isRequired,
  error: PropTypes.any,
  isLoading: PropTypes.bool
};

export default BetweenAccountsConfirmationTab;
